<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!irregularidades || !irregularidades.length">
        Não foram encontradas irregularidades com os filtros informados.
    </div>

    <div class="row" *ngIf="irregularidades && irregularidades.length">
        <div class="float-start letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
        <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
            [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao"
            (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-agente" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao"
                                    [atributo]="'agenteFinanceiroDestinatario'"
                                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            
                            <th id="col-data-inicio" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataInicio'"
                                    [nomeAtributoExibicao]="'Data. inicio'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-fim" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataFim'"
                                    [nomeAtributoExibicao]="'Data. fim'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-idOperacaoExterno" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoExterno'"
                                    [nomeAtributoExibicao]="'Id. externo operação:'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-sistema-contrato" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'"
                                    [nomeAtributoExibicao]="'Sist/Contrato'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                         
                            <th id="col-estado" scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'ativo'"
                                    [nomeAtributoExibicao]="'Responsável pela Última Alteração'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col" class="text-start">
                                ações
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let irregularidade of irregularidades">
                            <td>{{ nomeAgenteFinanceiro(irregularidade.idAgenteFinanceiro) }}</td>
                            <td>{{ irregularidade.dataInicio | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ irregularidade.dataFim | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ irregularidade.idOperacaoExterno }}</td>
                            <td>{{ irregularidade.contratoRepasse ? irregularidade.sistemaRepasse + '/' +
                                irregularidade.contratoRepasse : ''}}</td>
                            <td>{{ irregularidade.nomeUsuarioUltimaAtualizacao }}</td>

                            <td class="text-start" id=col-acoes>
                                <a [routerLink]="['/irregularidade', irregularidade.id]">
                                    <i class="fa fa-search cursor-pointer" placement="left-top"
                                        ngbTooltip="Visualizar/Editar Irregularidade"> </i></a>
                                <a href="javascript:void(0)" (click)="desativar(irregularidade)" *ngIf="!irregularidade.dataFim && podeCadastrarIrregularidade"> 
                                    <i class="fa fa-trash cursor-pointer margin-left-5"    placement="left-top" ngbTooltip="Desativar irregularidade"></i></a>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>